function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import Markdown from "segments/desktop/core-components/markdown/markdown";
import { StyledMarkdownEmbeddedComponent } from "./markdown-embedded-component.scss";
class MarkdownEmbeddedComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsx(StyledMarkdownEmbeddedComponent, {
            className: "markdown-embedded-component",
            children: /*#__PURE__*/ _jsx("div", {
                className: "markdown-wrapper",
                children: /*#__PURE__*/ _jsx(Markdown, _object_spread({}, this.props))
            })
        });
    }
}
export { MarkdownEmbeddedComponent as default };
MarkdownEmbeddedComponent.defaultProps = Markdown.defaultProps;
